import { Children } from 'react';
import Grid from '@material-ui/core/Grid';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { ClassNameMap } from '@material-ui/styles/withStyles';
import clsx from 'clsx';

interface GridifyChildrenProps {
	classes?: Partial<ClassNameMap<'container' | 'grid' | 'gridItem'>>;
}

const GridifyChildren: React.FC<GridifyChildrenProps> = ({ classes: cl = {}, children }) => {

	const classes = useStyles();

	const isMobile = useMediaQuery('(max-width: 800px)');

	return (
		<div className={clsx('gridify', cl.container)}>
			<Grid className={clsx(cl.grid)} container direction='row' justify='space-between'>
				{Children.map(children, child => {
					if (!child) return null;

					return (
						<Grid
							item
							xs={isMobile ? 12 : 6}
							className={clsx(classes.gridItem, classes.notRouterGridItem, cl.gridItem)}
						>
							{child}
						</Grid>
					);
				})}
			</Grid>
		</div>
	);
}

export default GridifyChildren;


const useStyles = makeStyles(theme => ({
	gridItem: {
		[theme.breakpoints.down(800)]: {
			paddingBottom: 8
		}
	},

	notRouterGridItem: {
		width: '10vw !important'
	}
}));